var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccessWindow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.8613 40C80.8613 62.092 62.9533 80 40.8613 80C18.7707 80 0.861328 62.092 0.861328 40C0.861328 17.908 18.7707 0 40.8613 0C62.9533 0 80.8613 17.908 80.8613 40Z",
    fill: "#ECF0F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5646 57.0571H22.05C19.922 57.0571 18.1953 55.3305 18.1953 53.2011V24.7265C18.1953 22.5971 19.922 20.8718 22.05 20.8718H56.3326C58.462 20.8718 60.1886 22.5971 60.1886 24.7265V43.5798",
    stroke: "#0033A0",
    strokeWidth: 2.036,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1953 31.4819H60.1886",
    stroke: "#0033A0",
    strokeWidth: 2.036,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7969 26.5C26.7969 27.8811 25.6767 29 24.296 29C22.917 29 21.7969 27.8811 21.7969 26.5C21.7969 25.1189 22.917 24 24.296 24C25.6767 24 26.7969 25.1189 26.7969 26.5Z",
    fill: "#0033A0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7695 26.5C33.7695 27.8811 32.6494 29 31.2687 29C29.888 29 28.7695 27.8811 28.7695 26.5C28.7695 25.1189 29.888 24 31.2687 24C32.6494 24 33.7695 25.1189 33.7695 26.5Z",
    fill: "#0033A0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7695 26.5C40.7695 27.8811 39.6507 29 38.2695 29C36.8884 29 35.7695 27.8811 35.7695 26.5C35.7695 25.1189 36.8884 24 38.2695 24C39.6507 24 40.7695 25.1189 40.7695 26.5Z",
    fill: "#0033A0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M66.194 52.3506C66.194 57.5666 61.966 61.7959 56.75 61.7959C51.534 61.7959 47.3047 57.5666 47.3047 52.3506C47.3047 47.1346 51.534 42.9052 56.75 42.9052C61.966 42.9052 66.194 47.1346 66.194 52.3506Z",
    stroke: "#0033A0",
    strokeWidth: 2.036,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1582 52.7832L55.3635 54.7485L59.2155 50.4005",
    stroke: "#0033A0",
    strokeWidth: 2.036,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessWindow);
export default __webpack_public_path__ + "static/media/success-window.f786f050e88bfc962b530c34d0304c08.svg";
export { ForwardRef as ReactComponent };